"use strict";

var HtmlParser = '__RMD_HTML_PARSER__';
exports.HtmlParser = typeof Symbol === 'undefined' ? HtmlParser : Symbol(HtmlParser);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-markdown/lib/symbols.js
// module id = 620
// module chunks = 0 15 16 17 18